import React from 'react';
import classnames from 'classnames';
import { DumboProps as Props } from '../types';
import ImageDumbView from '../Image';
import LiteratureDumbView from '../Literature';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType, getBlurredThumbStyles } from '../../_helpers';

import s from './Premium.scss';

const PremiumDumbView: React.FC<Props> = ({ ...dumboProps }) => {
  const { deviation, width, height, className } = dumboProps;
  const deviationType = getDeviationType(deviation);

  if (deviationType === DeviationTypes.IMAGE) {
    return <ImageDumbView {...dumboProps} />;
  }

  if (deviationType === DeviationTypes.LITERATURE) {
    return <LiteratureDumbView {...dumboProps} />;
  }

  return (
    <div
      className={classnames(s['root'], className)}
      style={{
        width: width || height,
        height: height || width,
      }}
    >
      <div
        className={s['cdn-blurred-thumb']}
        style={getBlurredThumbStyles(deviation)}
      />
    </div>
  );
};
PremiumDumbView.displayName = 'PremiumDumbView';

export default PremiumDumbView;
